import React, { useEffect, useState } from "react";
import { useAdminEvent } from "@/context/AppContext";
import { api } from "@/lib/api";
import { PageIntro } from "@/admin/ui";
import { fmtDateLong, fmtTimeShort } from "@/lib/format";
import { Car, MapPin } from "lucide-react";

export default function TransfersAdmin() {
  const { eventId } = useAdminEvent();
  const [rows, setRows] = useState([]);

  useEffect(() => { api.adminTransfers(eventId).then(setRows); }, [eventId]);

  return (
    <div>
      <PageIntro>Ground transfers arranged with the destination management company (DMC). In production these are generated from imported flight data.</PageIntro>
      {rows.length === 0 ? (
        <div className="premium-card p-8 text-center text-sm text-[hsl(var(--muted-foreground))]">No transfers yet.</div>
      ) : (
        <div className="space-y-3">
          {rows.map((t) => (
            <div key={t.id} className="premium-card p-4 flex items-start gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-lg bg-[hsl(var(--secondary)/0.12)] text-[hsl(var(--secondary))]"><Car className="h-5 w-5" /></div>
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <span className="text-[11px] uppercase tracking-wide font-semibold text-[hsl(var(--pc-gold))]">{t.direction}</span>
                  <span className="text-sm font-semibold text-[hsl(var(--primary))]">{t.transfer_type}</span>
                </div>
                <div className="text-sm text-[hsl(var(--muted-foreground))] mt-1 flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> {t.pickup_location}</div>
                <div className="text-xs text-[hsl(var(--muted-foreground))] mt-0.5">{fmtDateLong(t.pickup_datetime)} · {fmtTimeShort(t.pickup_datetime)} · {t.provider}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
